export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_expenseType') || '费用项目',
    field: 'expenseType',
    align: 'center',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'expenseType' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('item_label_currencyAmount') || '费用金额',
    field: 'currencyAmount',
    align: 'center',
    width: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        placeholder: that.$l('form_placeholder_currencyAmount') || '请输入费用金额',
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_contractAmount') || '合同总金额',
    field: 'contractAmount',
    align: 'center',
    width: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        placeholder: that.$l('form_placeholder_contractAmount') || '请输入合同总金额',
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payment_ratio') || '支付比例',
    field: 'v_paymentRatio',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_custCode') || '费用客户',
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'customer' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_order_no') || '订单编号',
    field: 'custtcNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'custtcNo' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_orgDepFullName') || '分摊部门',
    field: 'fullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depCode' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
